import React from 'react';
import { Timestamp } from '@bufbuild/protobuf/wkt';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment-timezone';

interface RelativeTimeProps {
    timestamp: Timestamp | null | undefined;
    className?: string;
}

const RelativeTime: React.FC<RelativeTimeProps> = ({ timestamp, className }) => {
    if (!timestamp || !timestamp.seconds) {
        return <span className={className}>-</span>;
    }

    const timestampMs = Number(timestamp.seconds) * 1000;
    const userTimezone = moment.tz.guess();
    const dateMoment = moment(timestampMs).tz(userTimezone);
    
    const absoluteTime = dateMoment.format('YYYY-MM-DD HH:mm:ss z');
    const relativeTime = moment(timestampMs).fromNow();

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id={`tooltip-${timestamp.seconds}`}>
                    {absoluteTime}
                </Tooltip>
            }
        >
            <span className={className} style={{ cursor: 'help' }}>
                {relativeTime}
            </span>
        </OverlayTrigger>
    );
};

export default RelativeTime;